// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8028835e","453":"85f0728e","455":"3cf83b98","458":"2181b6ab","977":"a088ebc7"}[chunkId] + ".chunk.js";
};